import React, { useState, useContext, useEffect } from 'react'

import Pal from '../components/Pal';

import ReactTyped from 'react-typed';
import StepContext from '../Contexts/StepContext';
import { useQuery } from '@tanstack/react-query';
import fetchServerResponse from '../severGetHandling';
import { ColorRing } from  'react-loader-spinner';
import FileLoader from '../fileloader';
import FileDisplay from '../components/FileDisplay';

function Dashboard(props) {
 const {incrementStepCount, setInitialContent} = useContext(StepContext)
 const [docs, setDocs] = useState([]);
 const [display, setDisplay] = useState(false);

 useEffect(()=>{
    setDisplay(false)
 }, [props]);

useEffect(()=>{
  const getDocs = async() =>{
      let response = await FileLoader('getdocumentlist');
      console.log(response);
      setDocs(response.response);
  }
  getDocs()
}, [])
  
 //calling useQuery
 const { data: serverGetResponse, isLoading } = useQuery(
  ["serverGetResponse", props.endpoint],
  () => fetchServerResponse(props.endpoint)
);

 const handleEnter = async(event)=>{
  event.preventDefault();
  document.getElementById('onboarding-button').disabled = true;
  // create a new docId;
  const responseOfIdCreated = await FileLoader("create");
  setInitialContent(responseOfIdCreated);
  incrementStepCount();
}
 const onCompleteHandler = () =>{
  setDisplay(true);
}
const handleContent = (initContent) =>{
  setInitialContent(initContent);
  incrementStepCount();
}
  const FileLoading = () => {
    if (docs) {
      
      // Create an array of FileDisplay components
      const fileDisplayComponents = docs.map((doc) => (
        <FileDisplay
          key={doc.docRef}  // Assuming docRef is unique for each document
          value={doc.title}
          onClick={() => handleContent(doc)}  // Pass the entire doc object to handleContent
        />
      ));

      return (
        <div>
          {/* Render the array of FileDisplay components */}
          {fileDisplayComponents}
        </div>
      );
    }

    return null; // Return null if docs is falsy (empty or undefined)
  };


  return (
    
    <div className='form-container'>
        <div className= 'form-card'>
          {isLoading ? (<ColorRing
            visible={true}
            height="80"
            width="80"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
          />):
          (<div className='pal-container'>
              <Pal/>
              <ReactTyped strings={[props.altcontent]} 
              typeSpeed={20} 
              onComplete={onCompleteHandler}/>
              
            </div>)
          }
          {display && <button id='onboarding-button' className="form-submit-button" onClick={handleEnter}>New Project</button>}
          {display && <div> {FileLoading()} </div>}
          
        </div>
  </div>
  )
}

export default Dashboard